import { MaintenanceTypeForm } from '@/models'
import type { TServiceTasksState } from '@/types/state-types'

export default <TServiceTasksState>{
  serviceTaskForm: new MaintenanceTypeForm(),
  isServiceTaskFormLoading: false
}
